import { WeightClass as WeightClass } from '../types/WeightClass';
import { atom } from 'jotai';
import { IncentiveApiData } from '../types/IncentivesDataType';
import { ResidentialIncentiveApiData } from '../types/ResidentialIncentivesDataType';
import { DropdownConstants } from '../constants/DropdownConstants';
export const showModal = atom<boolean>(true);
export const zipCode = atom<string>('');
export const status = atom<string>(DropdownConstants.ALL);
export const organizationType = atom<string>(DropdownConstants.ALL);
export const equipmentType = atom<string>(DropdownConstants.ALL);
export const incentivesData = atom<IncentiveApiData[]>([]);
export const residentialIncentivesData = atom<ResidentialIncentiveApiData[]>([]);
export const filteredIncentivesData = atom<IncentiveApiData[]>([]);
export const filteredResidentialIncentivesData = atom<ResidentialIncentiveApiData[]>([]);
export const filteredIncentivesDataIndex = atom<number>(0);
export const residentialIncentivesDataIndex = atom<number>(0);
export const incentiveType = atom<string>('');
export const weightClassData = atom<WeightClass[]>([]);
export const chargerType = atom<string>(DropdownConstants.ALL);
export const residentialIncentiveApplicableVehicleType = atom<string>(DropdownConstants.ALL);
export const residentialIncentiveElectricityProvider = atom<string>(DropdownConstants.ALL);
export const residentialIncentiveStatus = atom<string>(DropdownConstants.ALL);
export const residentialIncentiveGrantorType = atom<string>(DropdownConstants.ALL);
export const residentialEquipmentType = atom<string>(DropdownConstants.ALL);
export const selectedIncentivesData = atom<IncentiveApiData[]>([]);
export const selectedResidentialIncentiveData = atom<ResidentialIncentiveApiData[]>([]);
